import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import * as Sentry from "@sentry/react";
import { SENTRY_DSN, DOMAIN_ENV_MAP } from "./constants/sentry-constants.ts";

function getDeploymentEnvironment(hostname: string) {
	return DOMAIN_ENV_MAP[hostname] ?? null;
}

function initializeSentry(deploymentEnvironment: "SANDBOX" | "STAGE" | "PROD") {
	Sentry.init({
		dsn: SENTRY_DSN,
		integrations: [
			Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
		],
		environment: deploymentEnvironment,
		enableLogs: true,
	});
}

const deploymentEnvironment = getDeploymentEnvironment(
	window.location.hostname,
);

if (!import.meta.env.DEV && deploymentEnvironment) {
	initializeSentry(deploymentEnvironment);
}

const root = document.getElementById("root");
if (root === null) {
	throw new Error("React root element not found");
}
createRoot(root).render(
	<StrictMode>
		<App />
	</StrictMode>,
);
